import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=b807d756&scoped=true&"
import script from "./Coin.vue?vue&type=script&lang=js&"
export * from "./Coin.vue?vue&type=script&lang=js&"
import style0 from "./Coin.vue?vue&type=style&index=0&id=b807d756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b807d756",
  null
  
)

component.options.__file = "Coin.vue"
export default component.exports